// Dependencies
import React, { Component } from 'react';
import { getLanguage, withTranslation } from 'react-multi-lang';

// Primereact imports
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

// Styling
import './other-training-data.scss';

// Utils
import { OTHER_QUALIFICATION } from '../../../../common/constants';
import { formatAssociateDataToService } from '../../../../common/formatters/associate';
import { getOtherTrainingList, getTranslatedOtherTrainingOption } from '../../../../common/lists/qualification';

// Redux
import { connect } from 'react-redux';
import { getAssociateData, setEditMode } from '../../../../redux/actions/profile';
import ProfileService from '../../../../redux/services/profile';

const HQ_PROPS = [
    'cardioRespiratory', 'muscleHealth', 'muscleAmputees', 'muscleTMJ',
    'neuroHealth', 'neuroVestibular', 'dermaHealth', 'mentalHealth',
    'womensHealth', 'pelvicHealth', 'sportsHealth', 'oncology',
    'palliativeCare', 'occupational', 'emergencyDisaster', 'animalHealth',
    'publicHealth', 'communityHealth', 'schoolHealth', 'pediatrics',
    'gerontology', 'pain', 'intensiveCare', 'healthProtection'
];

class OtherTrainingDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            cardioRespiratory: null,
            muscleHealth: null,
            muscleAmputees: null,
            muscleTMJ: null,
            neuroHealth: null,
            neuroVestibular: null,
            dermaHealth: null,
            mentalHealth: null,
            womensHealth: null,
            pelvicHealth: null,
            sportsHealth: null,
            oncology: null,
            palliativeCare: null,
            occupational: null,
            emergencyDisaster: null,
            animalHealth: null,
            publicHealth: null,
            communityHealth: null,
            schoolHealth: null,
            pediatrics: null,
            gerontology: null,
            pain: null,
            intensiveCare: null,
            healthProtection: null,
            readOnlyMode: true
        };
    }

    componentDidMount() {
        const hq = this.props.associate.healthQualification;
        this.setState({
            cardioRespiratory: hq.cardioRespiratory,
            muscleHealth: hq.muscleHealth,
            muscleAmputees: hq.muscleAmputees,
            muscleTMJ: hq.muscleTMJ,
            neuroHealth: hq.neuroHealth,
            neuroVestibular: hq.neuroVestibular,
            dermaHealth: hq.dermaHealth,
            mentalHealth: hq.mentalHealth,
            womensHealth: hq.womensHealth,
            pelvicHealth: hq.pelvicHealth,
            sportsHealth: hq.sportsHealth,
            oncology: hq.oncology,
            palliativeCare: hq.palliativeCare,
            occupational: hq.occupational,
            emergencyDisaster: hq.emergencyDisaster,
            animalHealth: hq.animalHealth,
            publicHealth: hq.publicHealth,
            communityHealth: hq.communityHealth,
            schoolHealth: hq.schoolHealth,
            pediatrics: hq.pediatrics,
            gerontology: hq.gerontology,
            pain: hq.pain,
            intensiveCare: hq.intensiveCare,
            healthProtection: hq.healthProtection
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);
            const hq = associate.healthQualification;
            this.setState({
                cardioRespiratory: hq.cardioRespiratory,
                muscleHealth: hq.muscleHealth,
                muscleAmputees: hq.muscleAmputees,
                muscleTMJ: hq.muscleTMJ,
                neuroHealth: hq.neuroHealth,
                neuroVestibular: hq.neuroVestibular,
                dermaHealth: hq.dermaHealth,
                mentalHealth: hq.mentalHealth,
                womensHealth: hq.womensHealth,
                pelvicHealth: hq.pelvicHealth,
                sportsHealth: hq.sportsHealth,
                oncology: hq.oncology,
                palliativeCare: hq.palliativeCare,
                occupational: hq.occupational,
                emergencyDisaster: hq.emergencyDisaster,
                animalHealth: hq.animalHealth,
                publicHealth: hq.publicHealth,
                communityHealth: hq.communityHealth,
                schoolHealth: hq.schoolHealth,
                pediatrics: hq.pediatrics,
                gerontology: hq.gerontology,
                pain: hq.pain,
                intensiveCare: hq.intensiveCare,
                healthProtection: hq.healthProtection
            });
        }
    }

    activateEditMode() {
        this.setState({ readOnlyMode: false });
        this.props.setEditMode(true);
    }

    cancelEditMode() {
        let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);
        const hq = associate.healthQualification;
        this.setState({
            cardioRespiratory: hq.cardioRespiratory,
            muscleHealth: hq.muscleHealth,
            muscleAmputees: hq.muscleAmputees,
            muscleTMJ: hq.muscleTMJ,
            neuroHealth: hq.neuroHealth,
            neuroVestibular: hq.neuroVestibular,
            dermaHealth: hq.dermaHealth,
            mentalHealth: hq.mentalHealth,
            womensHealth: hq.womensHealth,
            pelvicHealth: hq.pelvicHealth,
            sportsHealth: hq.sportsHealth,
            oncology: hq.oncology,
            palliativeCare: hq.palliativeCare,
            occupational: hq.occupational,
            emergencyDisaster: hq.emergencyDisaster,
            animalHealth: hq.animalHealth,
            publicHealth: hq.publicHealth,
            communityHealth: hq.communityHealth,
            schoolHealth: hq.schoolHealth,
            pediatrics: hq.pediatrics,
            gerontology: hq.gerontology,
            pain: hq.pain,
            intensiveCare: hq.intensiveCare,
            healthProtection: hq.healthProtection,
            readOnlyMode: true
        });
        this.props.setEditMode(false);
    }

    saveChanges() {
        let associate = this.props.associate;
        associate.healthQualification = {
            cardioRespiratory: this.state.cardioRespiratory,
            muscleHealth: this.state.muscleHealth,
            muscleAmputees: this.state.muscleAmputees,
            muscleTMJ: this.state.muscleTMJ,
            neuroHealth: this.state.neuroHealth,
            neuroVestibular: this.state.neuroVestibular,
            dermaHealth: this.state.dermaHealth,
            mentalHealth: this.state.mentalHealth,
            womensHealth: this.state.womensHealth,
            pelvicHealth: this.state.pelvicHealth,
            sportsHealth: this.state.sportsHealth,
            oncology: this.state.oncology,
            palliativeCare: this.state.palliativeCare,
            occupational: this.state.occupational,
            emergencyDisaster: this.state.emergencyDisaster,
            animalHealth: this.state.animalHealth,
            publicHealth: this.state.publicHealth,
            communityHealth: this.state.communityHealth,
            schoolHealth: this.state.schoolHealth,
            pediatrics: this.state.pediatrics,
            gerontology: this.state.gerontology,
            pain: this.state.pain,
            intensiveCare: this.state.intensiveCare,
            healthProtection: this.state.healthProtection
        };

        ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), OTHER_QUALIFICATION)
        .then((response) => {
            this.setState({ readOnlyMode: true });
            this.props.setEditMode(false);
            this.props.getAssociateData(this.props.registrationRef);

            setTimeout(() => {
                let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);
                const hq = associate.healthQualification;
                this.setState({
                    cardioRespiratory: hq.cardioRespiratory,
                    muscleHealth: hq.muscleHealth,
                    muscleAmputees: hq.muscleAmputees,
                    muscleTMJ: hq.muscleTMJ,
                    neuroHealth: hq.neuroHealth,
                    neuroVestibular: hq.neuroVestibular,
                    dermaHealth: hq.dermaHealth,
                    mentalHealth: hq.mentalHealth,
                    womensHealth: hq.womensHealth,
                    pelvicHealth: hq.pelvicHealth,
                    sportsHealth: hq.sportsHealth,
                    oncology: hq.oncology,
                    palliativeCare: hq.palliativeCare,
                    occupational: hq.occupational,
                    emergencyDisaster: hq.emergencyDisaster,
                    animalHealth: hq.animalHealth,
                    publicHealth: hq.publicHealth,
                    communityHealth: hq.communityHealth,
                    schoolHealth: hq.schoolHealth,
                    pediatrics: hq.pediatrics,
                    gerontology: hq.gerontology,
                    pain: hq.pain,
                    intensiveCare: hq.intensiveCare,
                    healthProtection: hq.healthProtection
                });
            }, 1500);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
        });
    }

    updateFormComponent(column, value) {
        this.setState({ [column]: value });
    }

    formatQualificationOtherDataFormValues(sourceAssociate, language = "pt") {
        let associate = { healthQualification: {} };
        const hq = sourceAssociate.healthQualification;

        HQ_PROPS.forEach(prop => {
            if (typeof hq[prop] !== 'object' && hq[prop] !== null) {
                associate.healthQualification[prop] = { name: hq[prop], code: hq[prop] };
            } else if (typeof hq[prop] === 'object' && hq[prop] !== null) {
                associate.healthQualification[prop] = getTranslatedOtherTrainingOption(hq[prop].code, language);
            }
        });

        return associate;
    }

    render() {
        const { readOnlyMode } = this.state;
        const options = getOtherTrainingList(getLanguage());

        return (
            this.props.associate !== null && this.props.associate.healthQualification !== null ?
                <div className='grid'>
                    <div className='col-12'>
                        <div className="card p-fluid mgt-20">
                            <div className='grid'>
                                <div className='col-12 t-align-right'>
                                    {
                                        readOnlyMode === true ?
                                            <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                            :
                                            <>
                                                <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                                <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                            </>
                                    }
                                </div>
                                <div className='col-12 t-align-left'>
                                    <span><b>{this.props.t("profile.areas.qualification.areas.other.form-title")}</b></span>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="cardioRespiratory">{this.props.t("profile.areas.qualification.areas.other.cardio-respiratory")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="cardioRespiratory" value={this.state.cardioRespiratory} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("cardioRespiratory", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="muscleHealth">{this.props.t("profile.areas.qualification.areas.other.muscle-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="muscleHealth" value={this.state.muscleHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("muscleHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="muscleAmputees">{this.props.t("profile.areas.qualification.areas.other.muscle-amputees")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="muscleAmputees" value={this.state.muscleAmputees} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("muscleAmputees", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="muscleTMJ">{this.props.t("profile.areas.qualification.areas.other.muscle-tmj")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="muscleTMJ" value={this.state.muscleTMJ} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("muscleTMJ", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="neuroHealth">{this.props.t("profile.areas.qualification.areas.other.neuro-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="neuroHealth" value={this.state.neuroHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("neuroHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="neuroVestibular">{this.props.t("profile.areas.qualification.areas.other.neuro-vestibular")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="neuroVestibular" value={this.state.neuroVestibular} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("neuroVestibular", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="dermaHealth">{this.props.t("profile.areas.qualification.areas.other.derma-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="dermaHealth" value={this.state.dermaHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("dermaHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="mentalHealth">{this.props.t("profile.areas.qualification.areas.other.mental-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="mentalHealth" value={this.state.mentalHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("mentalHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="womensHealth">{this.props.t("profile.areas.qualification.areas.other.womens-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="womensHealth" value={this.state.womensHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("womensHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="pelvicHealth">{this.props.t("profile.areas.qualification.areas.other.pelvic-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="pelvicHealth" value={this.state.pelvicHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("pelvicHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="sportsHealth">{this.props.t("profile.areas.qualification.areas.other.sports-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="sportsHealth" value={this.state.sportsHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("sportsHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="oncology">{this.props.t("profile.areas.qualification.areas.other.oncology")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="oncology" value={this.state.oncology} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("oncology", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="palliativeCare">{this.props.t("profile.areas.qualification.areas.other.palliative-care")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="palliativeCare" value={this.state.palliativeCare} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("palliativeCare", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="occupational">{this.props.t("profile.areas.qualification.areas.other.occupational")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="occupational" value={this.state.occupational} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("occupational", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="emergencyDisaster">{this.props.t("profile.areas.qualification.areas.other.emergency-disaster")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="emergencyDisaster" value={this.state.emergencyDisaster} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("emergencyDisaster", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="animalHealth">{this.props.t("profile.areas.qualification.areas.other.animal-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="animalHealth" value={this.state.animalHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("animalHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="publicHealth">{this.props.t("profile.areas.qualification.areas.other.public-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="publicHealth" value={this.state.publicHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("publicHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="communityHealth">{this.props.t("profile.areas.qualification.areas.other.community-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="communityHealth" value={this.state.communityHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("communityHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="schoolHealth">{this.props.t("profile.areas.qualification.areas.other.school-health")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="schoolHealth" value={this.state.schoolHealth} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("schoolHealth", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="pediatrics">{this.props.t("profile.areas.qualification.areas.other.pediatrics")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="pediatrics" value={this.state.pediatrics} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("pediatrics", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="gerontology">{this.props.t("profile.areas.qualification.areas.other.gerontology")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="gerontology" value={this.state.gerontology} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("gerontology", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="pain">{this.props.t("profile.areas.qualification.areas.other.pain")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="pain" value={this.state.pain} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("pain", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="intensiveCare">{this.props.t("profile.areas.qualification.areas.other.intensive-care")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="intensiveCare" value={this.state.intensiveCare} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("intensiveCare", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="healthProtection">{this.props.t("profile.areas.qualification.areas.other.health-protection")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="healthProtection" value={this.state.healthProtection} disabled={readOnlyMode} options={options} optionLabel="name" onChange={(evt) => this.updateFormComponent("healthProtection", evt.value)}></Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>
                : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(OtherTrainingDataComponent));